import { render, staticRenderFns } from "./UserGuideButton.vue?vue&type=template&id=61f8cf26&scoped=true"
import script from "./UserGuideButton.vue?vue&type=script&lang=js"
export * from "./UserGuideButton.vue?vue&type=script&lang=js"
import style0 from "./UserGuideButton.vue?vue&type=style&index=0&id=61f8cf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8cf26",
  null
  
)

export default component.exports